import FormCrudCRUDContext from "context/FormCrudContex";
import React, { useContext } from "react";

export const PDFNationalTerritory = ({ values }) => {
  const {
    certificate_inspection_pre_boarding_corrected,
    date_corrected,
    commercial_invoice_corrected,
    value_duta_corrected
  } = values;
  const { opcional } = useContext(FormCrudCRUDContext);

  return (
    <div className="row">
      <div className="col">
        <p>
          <strong>Cert. de inspecc. preembarque: </strong>{" "}
          {certificate_inspection_pre_boarding_corrected}
        </p>

        <p>
          <strong>Fecha: </strong> {date_corrected}
        </p>
      </div>

      <div className="col">
        <p>
          <strong>Factura Comercial: </strong> {commercial_invoice_corrected}
        </p>
        {opcional && (
          <p>
            <strong>{opcional}: </strong> {value_duta_corrected}
          </p>
        )}
      </div>
    </div>
  );
};
